import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth.slice'
import matchDayRootReducer from './matchday'
import chatRootReducer from './chat'
import matchRootReducer from './match'
import userRootReducer from './user'
import manigaUserListReducer from './maniga-user-list.slice'
import botConfigurationReducer from './bot-configuration.slice'
import teamRootReducer from './team'
import adminRootReducer from './admin'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        chat: chatRootReducer,
        matchDay: matchDayRootReducer,
        match: matchRootReducer,
        manigaUserList: manigaUserListReducer,
        configuration: botConfigurationReducer,
        user: userRootReducer,
        team: teamRootReducer,
        admin: adminRootReducer
    }
})

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch